import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { initSentry } from './lib/observability/sentry';
import './styles/globals.css';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found — index.html must contain <div id="root"></div>');
}

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
